import { AxiosError } from "axios"
import { useQuery } from "react-query"
import { ResponseInformationNode } from "../../interfaces"
import { RequestParameters } from "components/Shared/Filters/interfaces"
import { getInformationSwitchingTree } from "../../service"
import { hasValidFilters } from "components/Shared/utils/utils"

const ALIAS_TREE_SWITCHING_QUERY = "informationTreeSwitchingQuery"
const FIELDS_TO_VALIDATE: Array<keyof RequestParameters> = [
	"departments",
	"categories",
	"vendors",
	"previousFrom",
	"previousTo",
	"currentFrom",
	"currentTo",
]

export const useGetInformationTreeSwitching = (
	filters: RequestParameters,
	select?: (data: ResponseInformationNode) => unknown
) => {
	const {
		isLoading: isPendingRequest,
		data: dataInformationTree,
		isError,
		error,
		refetch,
		isSuccess,
		isIdle,
	} = useQuery<any, AxiosError>(
		[ALIAS_TREE_SWITCHING_QUERY, filters],
		() => getInformationSwitchingTree(filters),
		{
			enabled: hasValidFilters(filters, FIELDS_TO_VALIDATE),
			retry: false,
			select,
			refetchOnReconnect: false,
			refetchOnWindowFocus: false,
		}
	)
	return {
		isPendingRequest,
		dataInformationTree,
		isError,
		error,
		refetch,
		isSuccess,
		isIdle,
	}
}
